// extracted by mini-css-extract-plugin
export default {"container":"About_container__WazHV","heading":"About_heading__fgkC7"};